import { render, staticRenderFns } from "./addCanteenDialog.vue?vue&type=template&id=56c3c4c6&"
import script from "./addCanteenDialog.vue?vue&type=script&lang=js&"
export * from "./addCanteenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports